import { NgModule } from '@angular/core';
import { StorageUrlPipe } from './storage-url/storage-url';
import { AgePipe } from './age/age';
@NgModule({
	declarations: [StorageUrlPipe,
    AgePipe],
	imports: [],
	exports: [StorageUrlPipe,
    AgePipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts